import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { answerPushLocation, onPushNavigate } from '../system/webPush'
import { syncLongRunNotice } from './longRunNotice'

/**
 * Mounted once for the signed-in app. The notifications themselves come from the server
 * through the service worker (public/push-sw.js), tab open or closed; this learns whether
 * the browser is already subscribed, follows a notification click into the app, and tells
 * the service worker which strategy is on screen.
 */
export function useLongRunNotifications() {
  const navigate = useNavigate()

  useEffect(() => {
    void syncLongRunNotice()
  }, [])

  useEffect(() => onPushNavigate((path) => navigate(path)), [navigate])

  useEffect(() => answerPushLocation(), [])
}
